<!-- 所有权限 -->
<template>
  <div class="right" style="">
    <div class="right-title" style="display: flex;">
      <div
        style="display:inlink-block;"
        class="right-title-item"
        :class="show_permiss == index ? 'right-title-item-checked' : ''"
        @click="showPermiss(index)"
        v-for="(item, index) in treeData"
        :key="index"
      >
        {{ item.label }}
      </div>
      <div
        v-if="allp"
        class="right-title-item"
        style="color:#6fc743"
        @click="allChecked"
      >
        全选 / 取消全选
      </div>
    </div>
    <div style="max-width: 700px;" :style="{ maxHeight: height + 'px' }">
      <el-scrollbar
        wrapStyle="overflow-x:hidden;"
        :style="{ height: height + 'px' }"
        ><!-- style="height: 580px;" -->
        <div v-for="(item, index) in treeData" :key="index">
          <div
            
            v-show="show_permiss == index"
            v-for="(citem, cindex) in item.childList"
            :key="cindex"
            class="el-form-item-fa"
          >
          <!-- @click="checkedAll(citem)" -->
            <el-form label-width="150px">
              <el-form-item
                :label="citem.label + '：'"
                size="large"
                style="margin:10px 0;font-size:16px !important;"
              >
                <el-checkbox-group
                  v-model="checked_list"
                  @change="checkedChange"
                >
                  <el-checkbox
                    border
                    size="large"
                    :label="ccitem.label"
                    v-for="(ccitem, ccindex) in citem.childList"
                    :key="ccindex"
                    style="margin:0 10px 0 0;"
                  ></el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-form>

            <!-- <div>{{ citem.label }}</div> -->
          </div>
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>
<script>
export default {
  name: "all-permission",
  props: {
    treeData: [],
    height: String,
    allp: {
      default: false,
      type: Boolean
    },
    treeData6: []
  },
  data() {
    return {
      show_permiss: 0,
      checked_list: []
    };
  },
  mounted() {},
  methods: {
    abc() {
      return;
    },
    checkedAll(res) {
      // console.log(res);
      var list = [];
      list = res.childList.map(item => {
        return item.label;
      });

      list.concat(this.checked_list);
      for (let i in this.checked_list) {
        list.push(this.checked_list[i]);
      }
      this.changeChecked(list);
    },
    showPermiss(key) {
      this.show_permiss = key;
      this.$emit("merchantSet", key);
    },
    allChecked() {
      if (this.checked_list.length == this.treeData6.length) {
        this.changeChecked([]);
      } else {
        var list = this.treeData6.map(item => {
          return item.label;
        });
        this.changeChecked(list);
      }
    },
    changeChecked(list) {
      this.checked_list = [];
      this.checked_list = list;
      this.checkedChange(this.checked_list);
    },
    checkedChange(e) {
      this.$emit("checkedChange", e);
    }
  }
};
</script>

<style scoped lang="less">
.right {
  width: 100%;
  max-width: 900px;
  margin-bottom: 10px;

  .right-title {
    // width: 100%;
    // height: 40px;
    background-color: #fff;
    display: flex;
    /* justify-content: left;
    align-items: center; */
    font-size: 16px;
    font-weight: 700;
    overflow-x: auto;
    .right-title-item {
      flex-shrink: 0;
      width: auto;
      min-width: 60px;
      height: 30px;
      padding: 5px;
      text-align: center;
      cursor: pointer;
      user-select: none;
      font-size: 14px;
    }
    .right-title-item-checked {
      background-color: #6fc743;
      color: #fff;
    }
  }
}
.el-form-item-fa {
  font-size: 16px !important;
  // border: 1px solid #ccc;
  padding: 10px 0;
  border-radius: 20px;
  margin: 10px;
  background-color: rgba(0, 0, 0, 0.02);
  cursor: pointer;
  // background-color: pink;
  // box-shadow: 0 0 10px #3a61c2;
  /*  /deep/.el-form-item__label{
    // color:#fff;
  } */
}
// rgba(50, 16, 109, 0.8);
.el-checkbox.is-bordered {
  padding: 9px 20px 9px 10px;
  border-radius: 4px;
  // border: 1px solid #fff;
  box-sizing: border-box;
  line-height: normal;
  height: 40px;
}

/deep/.el-form-item__label {
  cursor: pointer !important;
}
/* label {
  // color: #fff;
} */
</style>
